import React, { createContext, useContext, useEffect, useState } from "react";
import { useMsal } from "@azure/msal-react";

const UserContext = createContext({ roles: [] });

export const UserProvider = ({ children }) => {
  const { accounts } = useMsal();
  const [roles, setRoles] = useState([]);

  useEffect(() => {
    if (accounts.length > 0) {
      const account = accounts[0];
      const userRoles = account?.idTokenClaims?.roles || [];
      setRoles(userRoles);
    }
  }, [accounts]);

  return (
    <UserContext.Provider value={{ roles }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);
